/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SettingsSlidersH3Icon16Light } from './SettingsSlidersH3Icon16Light';
import { SettingsSlidersH3Icon16Regular } from './SettingsSlidersH3Icon16Regular';
import { SettingsSlidersH3Icon16Solid } from './SettingsSlidersH3Icon16Solid';
import { SettingsSlidersH3Icon20Light } from './SettingsSlidersH3Icon20Light';
import { SettingsSlidersH3Icon20Regular } from './SettingsSlidersH3Icon20Regular';
import { SettingsSlidersH3Icon20Solid } from './SettingsSlidersH3Icon20Solid';
import { SettingsSlidersH3Icon24Regular } from './SettingsSlidersH3Icon24Regular';
import { SettingsSlidersH3Icon24Solid } from './SettingsSlidersH3Icon24Solid';
import { SettingsSlidersH3Icon32Regular } from './SettingsSlidersH3Icon32Regular';
import { SettingsSlidersH3Icon64Regular } from './SettingsSlidersH3Icon64Regular';
var sizes = {
    16: {
        light: SettingsSlidersH3Icon16Light,
        regular: SettingsSlidersH3Icon16Regular,
        solid: SettingsSlidersH3Icon16Solid,
    },
    20: {
        light: SettingsSlidersH3Icon20Light,
        regular: SettingsSlidersH3Icon20Regular,
        solid: SettingsSlidersH3Icon20Solid,
    },
    24: {
        regular: SettingsSlidersH3Icon24Regular,
        solid: SettingsSlidersH3Icon24Solid,
    },
    32: {
        regular: SettingsSlidersH3Icon32Regular,
    },
    64: {
        regular: SettingsSlidersH3Icon64Regular,
    },
};
export var SettingsSlidersH3Icon = forwardRef('SettingsSlidersH3Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
